export default __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmEU9fCxc4EsA.woff2";